// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';

import Zimbabwe from '../_raw/flag/icon_flag_zimbabwe.png';

export default () => <img src={Zimbabwe} alt="Zimbabwe" />;
